export const buttongroupTokens = {
  buttongroup: {
    root: {
      borderColor: '{formField.borderColor}',
      borderRadius: '{borderRadius.sm}',
      background: '{surface.0}',
      height: '2rem'
    }
  }
};

export type ButtonGroupTokens = typeof buttongroupTokens;
